import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// In index.js (before rendering the app)
window.addEventListener("error", (event) => {
  console.error("Global JS Error:", event.error);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled Promise Rejection:", event.reason);
});

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
